var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMoneyBag = function SvgMoneyBag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#596379",
    clipPath: "url(#moneyBag_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m16.208 11.45-3.333-5.317.917-1.575c.5-.858.008-2.066-.842-2.066H7.075c-.858 0-1.35 1.225-.833 2.075L7.2 6.175l-3.3 5.267c-1.683 2.675.392 6.05 3.717 6.05h4.875c3.325 0 5.4-3.367 3.716-6.05zm-3.55-7.617s0 .042-.016.059l-1.125 1.925H8.533l-1.15-1.925s-.016-.042-.016-.059zm2.492 10.85c-.517.934-1.508 1.492-2.658 1.492H7.617c-1.15 0-2.142-.558-2.659-1.492-.45-.808-.416-1.725.075-2.516l3.134-4.992h3.791l3.134 4.992c.491.791.525 1.708.075 2.516z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.983 10.167h1.292c.467 0 .817.216.925.608H7.983v.567h2.209c-.125.375-.475.616-.917.616H7.983v.867H8.9l1.25 2.1h1.133l-1.375-2.208a1.56 1.56 0 0 0 1.317-1.375h.8v-.567h-.808a1.44 1.44 0 0 0-.567-.908h1.375V9.3H7.983z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "moneyBag_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
};
export default SvgMoneyBag;